import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ZefFormsModule } from '@zerops/zef/forms';
import { ZefPipesModule } from '@zerops/zef/pipes';
import { MaterialFormStackModule } from '@zerops/zerops/core/material-form-stack';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ZuiDocsTextModule } from '@zerops/zui/docs-text';
import { ZuiAutoscalingFormFieldModule } from '@zerops/zui/autoscaling-form-field';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { ZuiTipCardComponent } from '@zerops/zui/tip-card';
import {
  LocalStorageServiceStackFormComponent
} from './local-storage-service-stack-form.component';
import {
  LocalStorageServiceStackFormTranslationsModule
} from './local-storage-service-stack-form.translations';
import { HostnameFieldModule } from '../../fields';

@NgModule({
  declarations: [ LocalStorageServiceStackFormComponent ],
  imports: [
    CommonModule,
    ZefFormsModule,
    ZefPipesModule,
    MaterialFormStackModule,
    FormSectionModule,
    HostnameFieldModule,
    LocalStorageServiceStackFormTranslationsModule,
    ZuiDocsTextModule,
    ZuiAutoscalingFormFieldModule,
    ZuiSeparatorComponent,
    ZuiTipCardComponent
  ],
  exports: [ LocalStorageServiceStackFormComponent ]
})
export class LocalStorageServiceStackFormModule {

}
